module.exports = __webpack_public_path__ + "media/4.d5e0da8e.mp3";